import { TagCestaCurriculo } from './tag-cesta-curriculo';
export class RetornoTags {
	tags?: TagCestaCurriculo[];
}
